const PREDEFINED_EVENT_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[predefinedEventManagementExperience] createPredefinedEvent',
  SET_CREATED: '[predefinedEventManagementExperience] setCreated',
  EDIT: '[predefinedEventManagementExperience] editPredefinedEvent',
  DELETE: '[predefinedEventManagementExperience] deletePredefinedEvent'
}

export default PREDEFINED_EVENT_MANAGEMENT_EXPERIENCE_TYPES
